import type { ReactNode, FunctionComponent } from 'react';
import {
    ListItemButton,
    ListItemText,
    listItemTextClasses,
} from '@mui/material';
import { AddIcon } from './icons';

export type AddListItemButtonProps = {
    onClick: () => void;
    text: ReactNode;
    disabled?: boolean;
};

export const AddListItemButton: FunctionComponent<AddListItemButtonProps> = (
    props,
) => {
    return (
        <ListItemButton
            onClick={props.onClick}
            disabled={props.disabled}
            sx={(theme) => ({
                border: `dashed 2px ${theme.bino.color.lightGray}`,
                borderRadius: '4px',
                // marginBottom: 2,
                padding: 0,
                '& > div': {
                    margin: '-1px',
                    borderRadius: '4px',
                    padding: '16px !important',
                    background: theme.palette.background.paper,
                    textAlign: 'center',
                    color: theme.bino.color.gray,
                    textTransform: 'uppercase',
                },
                '& svg': {
                    verticalAlign: 'middle',
                },
                '&:hover > div': {
                    background: 'transparent',
                    padding: '17px !important',
                },
                '&:hover': {
                    border: `solid 1px ${theme.bino.color.lightGray}`,
                },
            })}
        >
            <ListItemText
                sx={(theme) => ({
                    [`& .${listItemTextClasses.primary}`]: {
                        textAlign: 'center',
                        fontSize: 12,
                        fontWeight: 'bold',
                        color: theme.bino.color.gray,
                        '& svg': {
                            verticalAlign: 'middle',
                            marginRight: 1,
                        },
                    },
                })}
                primary={
                    <>
                        <AddIcon />
                        {props.text}
                    </>
                }
            />
        </ListItemButton>
    );
};
